import React from 'react';

function SvgCarretArrowUpJAG(props) {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.00039 0.599609L7.60039 4.8349H0.400391L4.00039 0.599609Z"
        fill="black"
      />
    </svg>
  );
}

export default SvgCarretArrowUpJAG;
